module.exports = __webpack_public_path__ + "static/media/Vending2.26eded9d.png";